import { z } from "zod";
import { BaseFirestoreSchema } from "./firestore.schema";
import { DateTypeSchema } from "./core.schema";
import { TagSchema } from "./tag.schema";
import { FeatureFlagsSchema } from "./features.schema";

// Schemas

export const OldNumberFormatSchema = z.enum([
  "decimal",
  "roman",
  "lowerRoman",
  "alpha",
  "lowerAlpha",
]);

export const MinutesOrderingSchema = z.enum(["timestamps", "agenda"]);

export const LegislationNumberingFormatSchema = z.enum([
  "number",
  "yearNumber",
]);

export const LegislationNumberCounterSchema = z.object({
  year: z.number().int().optional(),
  number: z.number().int().nonnegative(),
});

export const SizeOptionsSchema = z.object({
  label: z.string(),
  name: z.string(),
  description: z.string(),
});

export const OrganizationTypeSchema = z.object({
  id: z.number(),
  name: z.string(),
  label: z.string(),
  sizeOptions: SizeOptionsSchema.array().optional(),
});

export const TenantSchema = BaseFirestoreSchema.extend({
  friendlyId: z.string(),
  name: z.string(),
  ownerId: z.string(),
  adminUsers: z.string().array(),
  editUsers: z.string().array(),
  viewUsers: z.string().array(),
  submitUsers: z.string().array(),
  noneUsers: z.string().array().optional(),
  subscriptionId: z.string().optional(),
  subscriptionStatus: z.string().optional(),
  ownerStripeCustomerId: z.string().optional(),
  ownerTermsAndConditionsAccepted: z.boolean().optional(),
  ownerTermsAndConditionsAcceptedAt: DateTypeSchema.optional(),
  ownerTermsAndConditionsAcceptedVersion: z.number().optional(),
  organizationType: z.string().optional(),
  organizationSize: z.string().optional(),
  organizationState: z.string().optional(),
  organizationMunicipalityType: z.string().optional(),
  organizationMunicipalityTypeId: z.string().optional(),
  organizationMunicipalityId: z.string().optional(),
  organizationMunicipalityName: z.string().optional(),
  organizationMunicipalityPopulation: z.number().optional(),
  timeZone: z.string().optional(),
  standardTags: TagSchema.array().optional(),
  numberFormat: OldNumberFormatSchema.optional(),
  minutesOrdering: MinutesOrderingSchema.optional(),
  ordinanceNumberingFormat: LegislationNumberingFormatSchema.optional(),
  billNumberingFormat: LegislationNumberingFormatSchema.optional(),
  lastBillNumber: LegislationNumberCounterSchema.optional(),
  lastOrdinanceNumber: LegislationNumberCounterSchema.optional(),
  resolutionNumberingFormat: LegislationNumberingFormatSchema.optional(),
  lastResolutionNumber: LegislationNumberCounterSchema.optional(),
  publishedAt: DateTypeSchema.optional(),
  featureFlags: FeatureFlagsSchema.optional(),
});

export const PublicTenantSchema = TenantSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  friendlyId: true,
  name: true,
  organizationType: true,
  organizationSize: true,
  organizationState: true,
  organizationMunicipalityType: true,
  organizationMunicipalityTypeId: true,
  organizationMunicipalityId: true,
  organizationMunicipalityName: true,
  organizationMunicipalityPopulation: true,
  timeZone: true,
  publishedAt: true,
});

// DTOs

export const CreateTenantDtoSchema = TenantSchema.partial().and(
  TenantSchema.required().pick({
    friendlyId: true,
    name: true,
    ownerId: true,
  })
);

export const PutTenantDtoSchema = CreateTenantDtoSchema;

export const PatchTenantDtoSchema = TenantSchema.partial();
